// extracted by mini-css-extract-plugin
export default {"Assistance":"Assistance_Assistance__zCypR","list":"Assistance_list__FuKcA","view-more":"Assistance_view-more__8QOGh"};